import Auth from "./Auth.js";
import List from "./List.js";
import EditCreate from "./EditCreate.js";
import Details from "./Details.js";

export default {
    auth: Auth,
    list: List,
    editCreate: EditCreate,
    details: Details,
};
